<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-medium-size-100">
      <md-button v-if="device_detail.fcm_token" class="md-warning f-right-padding" :disabled="isDisabled" @click="sendFetchLogsNotification()">Fetch Logs</md-button>&nbsp;
      <md-button v-if="device_detail.fcm_token" class="md-primary f-right-padding" :disabled="isDisabled" @click="sendMessageModal = true">Send Message</md-button>&nbsp;
      <md-button v-if="loginUserEmail != 'apppcm1400@gmail.com'" class="md-success f-right-padding" :disabled="isDisabled" @click="SyncDevices()">Sync Device</md-button>&nbsp;
      <md-button v-if="loginUserEmail != 'apppcm1400@gmail.com' && device_detail && device_detail.json_response && device_detail.json_response.ownership !== 'COMPANY_OWNED'" class="md-info f-right-padding" :disabled="isDisabled || esimRequestLoading" @click="RequestDeviceInfo()">
          {{ esimRequestLoading ? 'Fetching...' : 'Request Device Info' }}
          <span v-if="esimRequestLoading"><i class="fa fa-spinner fa-spin"></i></span>
      </md-button>&nbsp;
      <tabs :tab-name="['Basic', 'Hardware & Software', 'Network & Memory', 'Applications', 'Issues', 'Deleted History', 'Location', 'eSIM']" color-button="warning">
        <template slot="tab-pane-1">
          <div class="pt-10">
            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">Profile</th>
                            <td>
                              <a v-if="device_detail.profile_id" @click="$router.push({ path: 'view-profiles', query: { profile_id: device_detail.profile_id._id }})" href="javascript:void(0)">{{ device_detail.profile_id.profile_name }}</a>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <th>User</th>
                            <td>{{ userName }}</td>
                          </tr>
                          <tr>
                            <th>Serial Number</th>
                            <td>{{ device_detail.serialNumber }}</td>
                          </tr>
                          <tr>
                            <th>Battery Level</th>
                            <td>{{ batteryInfo.batteryLevel }}</td>
                          </tr>
                          <tr>
                            <th>Battery Checked At</th>
                            <td>{{ HumanReadableDateFormat(batteryInfo.batteryLevelTimeCreation) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">Enrollment</th>
                            <td>{{ HumanReadableDateFormat(device_detail.enrollmentTime) }}</td>
                          </tr>
                          <tr>
                            <th>Last Status Report</th>
                            <td>{{ HumanReadableDateFormat(device_detail.lastStatusReportTime) }}</td>
                          </tr>
                          <tr>
                            <th>Last Policy Sync</th>
                            <td>{{ HumanReadableDateFormat(device_detail.lastPolicySyncTime) }}</td>
                          </tr>
                          <tr>
                            <th>Applied State</th>
                            <td>{{ device_detail.appliedState }}</td>
                          </tr>
                          <tr>
                            <th>Management Mode</th>
                            <td>{{ device_detail.managementMode }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </div>
        </template>
        <template slot="tab-pane-2">
          <div class="pt-10">
            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-header>
                    <h4 class="title"><b>Hardware Details</b></h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">Brand</th>
                            <td>{{ device_detail.hardwareInfo.brand }}</td>
                          </tr>
                          <tr>
                            <th>Hardware</th>
                            <td>{{ device_detail.hardwareInfo.hardware }}</td>
                          </tr>
                          <tr>
                            <th>Device Baseband Version</th>
                            <td>{{ device_detail.hardwareInfo.deviceBasebandVersion }}</td>
                          </tr>
                          <tr>
                            <th>Manufacturer</th>
                            <td>{{ device_detail.hardwareInfo.manufacturer }}</td>
                          </tr>
                          <tr>
                            <th>Serial Number</th>
                            <td>{{ device_detail.hardwareInfo.serialNumber }}</td>
                          </tr>
                          <tr>
                            <th>Model</th>
                            <td>{{ device_detail.hardwareInfo.model }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-header>
                    <h4 class="title"><b>Software Details</b></h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">Android Version</th>
                            <td>{{ softwareInfo.androidVersion }}</td>
                          </tr>
                          <tr>
                            <th>Android Build Number</th>
                            <td>{{ softwareInfo.androidBuildNumber }}</td>
                          </tr>
                          <tr>
                            <th>Device Kernel Version</th>
                            <td>{{ softwareInfo.deviceKernelVersion }}</td>
                          </tr>
                          <tr>
                            <th>Bootloader Version</th>
                            <td>{{ softwareInfo.bootloaderVersion }}</td>
                          </tr>
                          <tr>
                            <th>Primary Language Code</th>
                            <td>{{ softwareInfo.primaryLanguageCode }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </div>
        </template>
        <template slot="tab-pane-3">
          <div class="pt-10">
            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-header>
                    <h4 class="title"><b>Network Details</b></h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">IMEI</th>
                            <td>{{ networkInfo.imei }}</td>
                          </tr>
                          <tr>
                            <th>WiFi Mac Address</th>
                            <td>{{ networkInfo.wifiMacAddress }}</td>
                          </tr>
                          <tr>
                            <th>Network Operator Name</th>
                            <td>{{ networkInfo.networkOperatorName }}</td>
                          </tr>
                          <tr v-if="networkInfo.telephonyInfos">
                            <th>Phone Number</th>
                            <td>{{ networkInfo.telephonyInfos[0].phoneNumber }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card>
                  <md-card-header>
                    <h4 class="title"><b>Memory Details</b></h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="w3-responsive">
                      <table class="ws-table-all">
                        <tbody>
                          <tr>
                            <th style="width: 30%">Total Ram</th>
                            <td>{{ device_detail.memoryInfo.totalRam }}</td>
                          </tr>
                          <tr>
                            <th>Total Internal Storage</th>
                            <td>{{ device_detail.memoryInfo.totalInternalStorage }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </div>
        </template>
        <template slot="tab-pane-4">
          <div class="pt-10">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-card>
                  <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <md-select class="box-textbox" placeholder="Search By State" v-model="search_state">
                              <md-option value="">State</md-option>
                              <md-option v-for="state in applicationStatArray" v-bind:key="state" :value="state">
                                {{ state }}
                              </md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <md-select class="box-textbox" placeholder="Source" v-model="search_source">
                              <md-option value="">Source</md-option>
                              <md-option v-for="source in applicationSourceArray" v-bind:key="source" :value="source">
                                {{ ReplaceString(source,"_"," ") }}
                              </md-option>
                          </md-select>
                        </md-field>
                      </div>
                  </div>
                  <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <md-input type="text" class="box-textbox" placeholder="Application Title" v-model="search_package_name"></md-input>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <md-input type="text" class="box-textbox" placeholder="Package Name" v-model="search_package_id"></md-input>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-10">
                          <md-button class="md-primary" :disabled="isDisabled"  @click="FilterApplications()">Search</md-button> 
                      </div>
                  </div>
                  <hr>
                  <md-card-content>
                    <md-table :value="queriedData" class="paginated-table table-striped table-hover table-full-width" table-header-color="green" md-fixed-header>
                      <md-table-toolbar>
                        <md-field>
                          <label for="pages">Per page</label>
                          <md-select v-model="pagination.perPage" name="pages">
                            <md-option
                              v-for="item in pagination.perPageOptions"
                              :key="item"
                              :label="item"
                              :value="item"
                            >
                              {{ item }}
                            </md-option>
                          </md-select>
                        </md-field>
                      </md-table-toolbar>
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Display Name">{{ item.displayName }}
                          <small>( {{ item.packageName }} )</small>
                        </md-table-cell>
                        <md-table-cell md-label="Source">{{ ReplaceString(item.applicationSource, "_", " ") }}</md-table-cell>
                        <md-table-cell md-label="State / Version Name/ Version Code">{{ item.state }}
                          <small>( {{ item.versionName }} )</small>
                          <small>( {{ item.versionCode }} )</small>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </md-card-content>
                  <md-card-actions md-alignment="space-between">
                    <div class="">
                      <p class="card-category">
                        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                      </p>
                    </div>
                    <pagination
                      class="pagination-no-border pagination-success"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </pagination>
                  </md-card-actions>
                </md-card>
              </div>
            </div>
          </div>
        </template>
        <template slot="tab-pane-5">
          <div class="pt-10">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-card>
                  <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <md-input type="text" class="box-textbox" placeholder="Package ID" v-model="nonCompliancePackageId"></md-input>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-10">
                          <md-button class="md-primary" :disabled="isDisabled"  @click="filterNonComplianceDetails()">Search</md-button> 
                      </div>
                  </div>
                  <hr>
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 md-small-size-100">
                        <h4 v-if="nonComplianceDetails.length == 0">No data found</h4>
                        <md-table v-else v-model="nonComplianceDetails" table-header-color="green">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Package Name">{{ item.packageName }}</md-table-cell>
                            <md-table-cell md-label="Setting Name">{{ item.settingName }}</md-table-cell>
                            <md-table-cell md-label="Reason">{{ item.nonComplianceReason }}</md-table-cell>
                            <md-table-cell md-label="Installation Failer Reason">{{ item.installationFailureReason }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </div>
        </template>
        <template slot="tab-pane-6">
          <md-card>
              <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-small-size-100">
                      <h4 v-if="deletedDevices.length == 0">No history found</h4>
                      <md-table v-else v-model="deletedDevices" table-header-color="green">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label="Profile">
                            <a v-if="item.profile_id" href="javascript:void(0)" @click="$router.push({ path: 'view-profiles', query: { profile_id: device_detail.profile_id._id }})">{{ item.profile_id.profile_name }}</a>
                            <span v-else>-</span>
                          </md-table-cell>
                          <md-table-cell md-label="Serial Number">{{ item.serialNumber }}</md-table-cell>
                          <md-table-cell md-label="Deleted At">{{ HumanReadableDateFormat(item.deleted_at) }}</md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-7">
          <md-card>
              <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <h3>Last Location</h3>
                      <FleetMap :devicesLocation="devicesLocations" />
                    </div>
                  </div>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-8">
          <md-card>
            <md-card-content>
              <div class="md-layout">

                <!-- Physical SIM Section -->
                <div class="md-layout-item md-size-100" v-if="esimInfo.telephonyInfos && esimInfo.telephonyInfos.length > 0">
                  <h4><b>Physical SIM</b></h4>
                  <table class="ws-table-all">
                    <tbody>
                      <tr v-for="(sim, index) in esimInfo.telephonyInfos" :key="index">
                        <th style="width: 30%">SIM {{ index + 1 }}</th>
                        <td>
                          <b>Carrier:</b> {{ sim.carrierName || '-' }}<br>
                          <b>ICCID:</b> {{ sim.iccId || '-' }}<br>
                          <b>Activation State:</b> {{ sim.activationState || '-' }}<br>
                          <b>Config Mode:</b> {{ sim.configMode || '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br>
                </div>

                <!-- No Device Info Yet -->
                <div class="md-layout-item md-size-100" v-if="!esimInfo.eid">
                    <div style="text-align: center; padding: 30px; border: 1px dashed #ccc; border-radius: 8px;">
                        <md-icon style="font-size: 48px; color: #aaa;">sim_card</md-icon>
                        <h4 style="color: #666;">eSIM information not available</h4>
                        <p style="color: #999;" v-if="device_detail.json_response && device_detail.json_response.ownership === 'COMPANY_OWNED'">
                            Click "Sync Device" to fetch the latest device info including eSIM details.
                        </p>
                        <p style="color: #999;" v-else>
                            Click "Request Device Info" to fetch eSIM details from the device.
                        </p>
                        <md-button class="md-success" :disabled="isDisabled" 
                            v-if="device_detail.json_response && device_detail.json_response.ownership === 'COMPANY_OWNED'"
                            @click="SyncDevices()">
                            Sync Device
                        </md-button>
                        <md-button class="md-info" :disabled="isDisabled || esimRequestLoading"
                            v-else
                            @click="RequestDeviceInfo()">
                            {{ esimRequestLoading ? 'Fetching...' : 'Request Device Info' }}
                        </md-button>
                    </div>
                </div>

                <!-- eSIM Info Available -->
                <div class="md-layout-item md-size-100" v-if="esimInfo.eid">
                  <h4><b>eSIM Details</b></h4>
                  <table class="ws-table-all">
                    <tbody>
                      <tr>
                        <th style="width: 30%">EID</th>
                        <td>{{ esimInfo.eid }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <br>

                  <!-- No eSIM profile active - show Add -->
                  <div v-if="!esimInfo.activeEsim">
                    <h4><b>Add eSIM</b></h4>
                    <p style="color: #666;">No eSIM profile is currently active on this device.</p>
                    <md-button class="md-success" :disabled="isDisabled" @click="AddEsim()">
                      Add eSIM
                    </md-button>
                  </div>

                  <!-- eSIM profile active - show Remove -->
                  <div v-if="esimInfo.activeEsim">
                    <h4><b>Active eSIM Profile</b></h4>
                    <table class="ws-table-all">
                      <tbody>
                        <tr>
                          <th style="width: 30%">Carrier</th>
                          <td>{{ esimInfo.activeEsim.carrierName || '-' }}</td>
                        </tr>
                        <tr>
                          <th>ICCID</th>
                          <td>{{ esimInfo.activeEsim.iccId || '-' }}</td>
                        </tr>
                        <tr>
                          <th>Activation State</th>
                          <td>{{ esimInfo.activeEsim.activationState || '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                    <md-button class="md-danger" :disabled="isDisabled" @click="RemoveEsim()">
                      Remove eSIM
                    </md-button>
                  </div>
                </div>

              </div>
            </md-card-content>
          </md-card>
        </template>
      </tabs>
    </div>
    <!--sendMessageModal Modal -->
    <template>
        <modal v-if="sendMessageModal" @close="sendMessageModal = false">
          <template slot="header">
            <h4 class="modal-title">Send Message To Device</h4>
            <md-button
              style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
              @click="sendMessageModal = false"><md-icon>clear</md-icon></md-button>
          </template>
          <template slot="body">
          <div class="box-body">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Message</label>
                  <md-input type="text" v-model="fcmMessage"></md-input>
                </md-field>
              </div>
            </div>
          </div>
          </template>
          <template slot="footer">
            <md-button class="md-danger md-simple" @click="sendMessageModal = false">Close</md-button>
            <md-button class="md-success mt-1" type="submit" :disabled="isDisabled" @click="sendFcmPush()">Send</md-button>
          </template>
        </modal>
    </template>

    <template>
        <modal v-if="addEsimModal" @close="addEsimModal = false">
            <template slot="header">
                <h4 class="modal-title">Add eSIM</h4>
                <md-button style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
                    @click="addEsimModal = false"><md-icon>clear</md-icon></md-button>
            </template>
            <template slot="body">
                <div class="box-body">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Activation Code</label>
                                <md-input type="text" v-model="esimActivationCode" 
                                    placeholder="e.g. LPA:1$smdp.example.com$ACTIVATION_CODE">
                                </md-input>
                            </md-field>
                            <small style="color: #999;">Enter the eSIM activation code provided by the carrier.</small>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <md-button class="md-danger md-simple" @click="addEsimModal = false">Cancel</md-button>
                <md-button class="md-success" :disabled="isDisabled" @click="ConfirmAddEsim()">Add eSIM</md-button>
            </template>
        </modal>
    </template>
  </div>
</template>
<script>
import DeviceProceDataService from "../../services/DeviceProceDataService";
import UserDataService from "../../services/UsersDataService";
import { Modal, Tabs } from "@/components";
import { Pagination } from "@/components";
import FleetMap from "@/components/FleetMap.vue";

export default {
  components: {
    Tabs,
    Pagination,
    Modal,
    FleetMap
  },
  data() {
    return {
      loginUserEmail: "",
      device_detail: {},
      batteryInfoArray: [],
      applicationArray: [],
      applicationArrayBackup: [],
      applicationStatArray: [],
      applicationSourceArray: [],
      search_state: "",
      search_source: "",
      search_package_name: "",
      search_package_id: "",
      isDisabled: false,

      profileApplications: [],
      nonComplianceDetails:[],
      nonComplianceDetailsBackup: [],
      nonCompliancePackageId: "",

      //Deleted Devices
      deletedDevices: [],

      sendMessageModal: false,
      fcmMessage:"",

      // Pagination
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      searchedData: [],
      iframeMapUrl: "",

      devicesLocations: [],
      // eSIM
      esimRequestLoading: false,
      esimInfo: {
          telephonyInfos: null,
          eid: null,
          activeEsim: null,
      },
      addEsimModal: false,
      esimActivationCode: "",
    }
  },
  computed: {
    // Add inside computed:
    esimData: function() {
        if (!this.device_detail || !this.device_detail.json_response) return {};
        return this.device_detail.json_response;
    },
    userName: function () {
      return (this.device_detail.user_id) ? this.device_detail.user_id.user_name : "-"
    },
    softwareInfo: function() {
      return {
        androidVersion: (this.device_detail.json_response.softwareInfo) ? this.device_detail.json_response.softwareInfo.androidVersion : "-",
        androidBuildNumber: (this.device_detail.json_response.softwareInfo) ? this.device_detail.json_response.softwareInfo.androidBuildNumber : "-",
        deviceKernelVersion: (this.device_detail.json_response.softwareInfo) ? this.device_detail.json_response.softwareInfo.deviceKernelVersion : "-",
        bootloaderVersion: (this.device_detail.json_response.softwareInfo) ? this.device_detail.json_response.softwareInfo.bootloaderVersion : "-",
        primaryLanguageCode: (this.device_detail.json_response.softwareInfo) ? this.device_detail.json_response.softwareInfo.primaryLanguageCode : "-",
      }
    },
    networkInfo: function() {
      return {
        imei: (this.device_detail.json_response.networkInfo) ? this.device_detail.json_response.networkInfo.imei : "-",
        wifiMacAddress: (this.device_detail.json_response.networkInfo) ? this.device_detail.json_response.networkInfo.wifiMacAddress : "-",
        networkOperatorName: (this.device_detail.json_response.networkInfo) ? this.device_detail.json_response.networkInfo.networkOperatorName : "-",
        telephonyInfos: (this.device_detail.json_response.networkInfo.hasOwnProperty("telephonyInfos")) ? this.device_detail.json_response.networkInfo.telephonyInfos : null,
      }
    },
    batteryInfo: function() {
      return {
        batteryLevel: (this.batteryInfoArray.length > 0) ? this.batteryInfoArray[this.batteryInfoArray.length-1].batteryLevel : "-",
        batteryLevelTimeCreation: (this.batteryInfoArray.length > 0) ? this.batteryInfoArray[this.batteryInfoArray.length-1].createTime : "-",
        batteryEvent: (this.batteryInfoArray.length > 0) ? this.batteryInfoArray[this.batteryInfoArray.length-1].eventType : "-",
      }
    },

    // Pagination
    queriedData() {
      let result = this.applicationArray;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.applicationArray.length;
    },
  },
  methods: {
    GetDeviceDetail() {
      DeviceProceDataService.GetDeviceDetail(this.$route.query.device_id)
        .then((response) => {
          this.device_detail = response.data.data;
          this.devicesLocations = response?.data?.devicesLocations
          if (this.device_detail.json_response.nonComplianceDetails) {
            this.nonComplianceDetails = this.device_detail.json_response.nonComplianceDetails;
            this.nonComplianceDetailsBackup = this.device_detail.json_response.nonComplianceDetails;
          }

          this.GetProfileApplicationList(this.device_detail.profile_id._id);

          this.batteryInfoArray = this.device_detail.json_response.powerManagementEvents.filter(i => i.eventType == "BATTERY_LEVEL_COLLECTED");
          if (this.device_detail.json_response.applicationReports) {
            this.applicationArray = this.device_detail.json_response.applicationReports;
            this.applicationArrayBackup = this.device_detail.json_response.applicationReports;
            if (this.applicationArray.length > 0) {
              this.applicationArray.forEach(application => {
                if (! this.applicationStatArray.includes(application.state)){
                  this.applicationStatArray.push(application.state)
                }

                if (! this.applicationSourceArray.includes(application.applicationSource) && application.applicationSource != undefined) {
                  this.applicationSourceArray.push(application.applicationSource)
                }
              });
            }
          }
          let lastDeviceLocation = response.data.lastDeviceLocation;
          if (lastDeviceLocation) {
            const centerLat = lastDeviceLocation?.latitude;   // Latitude of your center
            const centerLong = lastDeviceLocation?.longitude;  // Longitude of your center
            const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

            const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
            const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
            this.iframeMapUrl = `/map.html?lat=${centerLat}&long=${centerLong}&zoom=12&bbox=${bbox}`;
          }
          this.ParseEsimInfo();
        })
        .catch((e) => {
          if (e.response) {
            this.$toast.error(e.response.data.respones_msg);
          }
        });
    },
    calculateBoundingBox(latStr, longStr, zoomOutFactor) {
        const latitude = parseFloat(latStr);
        const longitude = parseFloat(longStr);

        // Check if the conversion was successful (NaN check)
        if (isNaN(latitude) || isNaN(longitude)) {
            console.error("Invalid latitude or longitude string");
            return null;
        }

        // Calculate the bounding box by subtracting/adding the zoomOutFactor to the center point coordinates
        const west = longitude - zoomOutFactor;
        const east = longitude + zoomOutFactor;
        const south = latitude - zoomOutFactor;
        const north = latitude + zoomOutFactor;
        
        // Return the bounding box as an object
        return {
            west: west,
            south: south,
            east: east,
            north: north
        };
    },
    FilterApplications() {
      this.applicationArray = this.applicationArrayBackup;
      if (this.search_source) {
        this.applicationArray = this.applicationArray.filter(i => i.applicationSource == this.search_source)          
      }
      if (this.search_state) {
        this.applicationArray = this.applicationArray.filter(i => i.state == this.search_state);        
      } 
      if (this.search_package_name) {
        this.applicationArray = this.applicationArray.filter(i => 
          (i.displayName)  ? i.displayName.indexOf(this.search_package_name) > -1 : false
          //i.displayName.indexOf(this.search_package_name) > -1
        );        
      }
      if (this.search_package_id) {
        this.applicationArray = this.applicationArray.filter(i => i.packageName.indexOf(this.search_package_id) > -1);        
      }
    },

    filterNonComplianceDetails() {
      this.nonComplianceDetails = this.nonComplianceDetailsBackup;
      if (this.nonCompliancePackageId) {
        this.nonComplianceDetails = this.nonComplianceDetails.filter(i => i.packageName.indexOf(this.nonCompliancePackageId) > -1);
      }
    },

    SyncDevices() {
      this.isDisabled = true;
      DeviceProceDataService.SyncDevices(this.$route.query.device_id)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
          this.GetDeviceDetail();
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    GetAdminDetail() {
      var data = {};
      UserDataService.getUserDetail(data)
        .then((response) => {
          this.loginUserEmail = response.data.data.email;
          
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    deletedHistory() {
      let data = {
        id: this.$route.query.device_id, 
      }
      DeviceProceDataService.deletedHistory(data)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.deletedDevices = response.data.data;
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    GetProfileApplicationList(profileId) {
      this.profileApplications = [];
      let nonComplianceDetails = this.nonComplianceDetails;
      let existApplications = [];

      DeviceProceDataService.GetProfileApplicationList(
        profileId, ""
      )
        .then((response) => {
          if (response.data.data) {
            this.profileApplications = response.data.data;
            if (this.profileApplications.length > 0) {
              this.profileApplications.forEach(function (item, index) {
                let applicationExist = nonComplianceDetails.some(el => el.packageName === item.package_name);
                if (applicationExist) {
                  //Remove from the array list
                  existApplications.push(item.package_name)
                }
              });
              nonComplianceDetails = nonComplianceDetails.filter(function(obj) {
                  return this.has(obj.packageName);
              }, new Set(existApplications.map(obj => obj)));
              this.nonComplianceDetails = nonComplianceDetails;
              this.nonComplianceDetailsBackup = nonComplianceDetails;
            }
          }
        })
        .catch((e) => {
          this.$toast.error(e);
        });
    },

    sendFcmPush() {
      this.isDisabled = true;
      let data = {
        id: this.$route.query.device_id,
        message: this.fcmMessage
      }
      DeviceProceDataService.sendFcmPush(data)
        .then((response) => {
          this.isDisabled = false;
          this.sendMessageModal = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async sendFetchLogsNotification() {
      this.isDisabled = true;
      let data = {
        id: this.$route.query.device_id,
      }
      await DeviceProceDataService.sendFetchLogsNotification(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    // Parse eSIM info from device_detail
    ParseEsimInfo() {
        if (!this.device_detail || !this.device_detail.json_response) return;
        const json = this.device_detail.json_response;

        // Physical SIM
        this.esimInfo.telephonyInfos = json.networkInfo?.telephonyInfos || null;

        // EID from hardwareInfo for company-owned devices
        // For BYOD devices it comes from REQUEST_DEVICE_INFO command
        const isCompanyOwned = json.ownership === 'COMPANY_OWNED';
        if (isCompanyOwned) {
            this.esimInfo.eid = json.hardwareInfo?.eid || null;
        } else {
            this.esimInfo.eid = json.hardwareInfo?.eid || null; // populated after REQUEST_DEVICE_INFO
        }

        // Active eSIM — check telephonyInfos for eSIM entry
        if (this.esimInfo.telephonyInfos) {
            const esimEntry = this.esimInfo.telephonyInfos.find(
                sim => sim.configMode === 'ESIM_MANAGED' || sim.iccId?.startsWith('89049')
            );
            this.esimInfo.activeEsim = esimEntry || null;
        }
    },

    async RequestDeviceInfo() {
        this.esimRequestLoading = true;
        try {
            const commandData = {
                type: "REQUEST_DEVICE_INFO",
                name: this.device_detail.name,
            };
            await DeviceProceDataService.IssueCommand(commandData);
            this.$toast.success("Device info requested. Syncing in 3 seconds...");

            // First sync attempt after 3 seconds
            setTimeout(async () => {
                await this.SyncDevicesAndParseEsim();

                // Check if EID found, if not try again after 5 more seconds
                if (!this.esimInfo.eid) {
                    this.$toast.info("Waiting for device response, retrying sync...");
                    setTimeout(async () => {
                        await this.SyncDevicesAndParseEsim();
                        if (!this.esimInfo.eid) {
                            this.$toast.warning("Device info not yet available. Device may be offline or eSIM not supported.");
                        }
                        this.esimRequestLoading = false;
                    }, 5000);
                } else {
                    this.esimRequestLoading = false;
                }
            }, 3000);

        } catch (e) {
            this.esimRequestLoading = false;
            this.$toast.error(e.response?.data?.respones_msg || "Failed to request device info.");
        }
    },

    async SyncDevicesAndParseEsim() {
        return new Promise((resolve) => {
            DeviceProceDataService.SyncDevices(this.$route.query.device_id)
                .then((response) => {
                    this.GetDeviceDetail();
                    setTimeout(() => {
                        this.ParseEsimInfo();
                        resolve();
                    }, 500);
                })
                .catch(() => resolve());
        });
    },

    AddEsim() {
        this.addEsimModal = true;
    },

    ConfirmAddEsim() {
        if (!this.esimActivationCode) {
            this.$toast.error("Please enter the eSIM activation code.");
            return;
        }
        this.isDisabled = true;
        let data = {
            type: "ADD_ESIM",
            name: this.device_detail.name,
            addEsimParams: {
                activationCode: this.esimActivationCode,
                activationState: "ACTIVATED"
            }
        };
        DeviceProceDataService.IssueCommand(data)
            .then((response) => {
                this.isDisabled = false;
                this.addEsimModal = false;
                this.esimActivationCode = "";
                this.$toast.success("eSIM add command sent successfully.");
                setTimeout(() => this.SyncDevicesAndParseEsim(), 3000);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response?.data?.respones_msg || "Failed to add eSIM.");
            });
    },

    RemoveEsim() {
        // Issue REMOVE_ESIM command
        let data = {
            type: "REMOVE_ESIM",
            name: this.device_detail.name,
        };
        DeviceProceDataService.IssueCommand(data)
            .then((response) => {
                this.$toast.success("eSIM removal command sent successfully.");
                setTimeout(() => this.SyncDevicesAndParseEsim(), 3000);
            })
            .catch((e) => {
                this.$toast.error(e.response?.data?.respones_msg || "Failed to remove eSIM.");
            });
    },
  },
  beforeMount() {
    this.GetDeviceDetail();
    this.GetAdminDetail();
    this.deletedHistory();
  },
  mounted: function () {
    this.$nextTick(() => {
      const that = this;
      $("#4").on("click", function() {
        alert(121);
      });
    })
  }
};
</script>
<style scoped>
.pt-10 {
  padding-top: 10px;
}
.w3-responsive {
    display: block;
    overflow-x: auto;
}
.ws-table-all {
    /*border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ccc;*/
    width: 100%;
    display: table;
}
.ws-table-all tr, .ws-table-all td {
    /*border: 1px solid black;
    border-collapse: collapse;*/
}
.ws-table-all td {
    padding: 5px;
}
.ws-table-all th {
    text-align: left;
}
audio:not(.md-image), canvas:not(.md-image), embed:not(.md-image), iframe:not(.md-image), img:not(.md-image), object:not(.md-image), video:not(.md-image) {
  height: revert-layer !important;
}
</style>